import MuiTextField from "@mui/material/TextField";
import type { TextFieldProps } from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import { forwardRef } from "react";

const StyledOutlinedTextField = styled(MuiTextField)(({ theme }) => ({
  "& .MuiInputLabel-root": {
    color: theme.palette.grey[120],
    "&.Mui-focused": {
      color: theme.palette.grey[120],
    },
    "&.Mui-disabled": {
      color: theme.palette.grey[60],
    },
  },

  "& .MuiInputLabel-sizeSmall": {
    ...theme.typography.TextS,
  },

  "& .MuiOutlinedInput-root": {
    borderRadius: theme.shape.borderRadiusSmall,
    color: theme.palette.primary.main,

    "&.MuiInputBase-sizeSmall": {
      ...theme.typography.TextS,
    },

    "& .MuiSelect-icon": {
      fontSize: "16px",
      color: "inherit",
    },

    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.grey[60],
    },

    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main,
      borderWidth: "1px",
    },

    "&.Mui-disabled": {
      color: theme.palette.grey[60],
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.grey[60],
      },
    },
  },
  "& .MuiInputAdornment-positionEnd": {
    color: "inherit",
  },
  "& .MuiInputLabel-root.Mui-error:not(.Mui-disabled)": {
    color: theme.palette.error.main,
  },
  "& .MuiOutlinedInput-root.Mui-error:not(.Mui-disabled) .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.error.main,
  },
  '&[data-highlight="true"] .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline, &[data-highlight="true"] .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
    {
      borderColor: theme.palette.secondary1[100],
      borderWidth: "2px",
    },
}));

const OutlinedTextField = forwardRef<HTMLDivElement, TextFieldProps>(({ size = "small", ...rest }, ref) => (
  <StyledOutlinedTextField ref={ref} {...rest} size={size} variant="outlined" />
)) as typeof MuiTextField;

export default OutlinedTextField;
